<template>
  <div class="LiveDetails subWrapper">
    <!-- logo + menu -->
    <LogoMenu v-if="ispc" :loadmounted="ispc" :active-name="menuName" />
    <!-- pc -->
    <div class="sub_contBox">
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/liveHighlights', query: { name: name } }">{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item>现场花絮详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <div class="live-theme-box">
          <!-- 图片 -->
          <img src="../assets/image/xchx2018.jpg" class="live-img" />
          <!-- 文字 -->
          <p class="live-txt">2021中国（上海）国际隧道工程研讨会圆满闭幕。这是一场超高规格、超高水准的学术盛会；这是一场立意高远、内容丰盛的思想盛宴。为期2天的会议，共设置1个主旨论坛，6个主题论坛，来自中国、日本、意大利、奥地利、巴西等多个国家行业人士通过线上线下的模式共襄盛举，通过近100个学术报告共同探讨“城市复杂环境下隧道工程的挑战与创新”，为城市地下空间建设发展汇聚创新力量与智慧方案。接下来，就请随着摄影师的镜头一起回顾精彩瞬间，定格美好回忆吧！</p>
          <!-- 分割线 -->
          <p class="live-line"></p>
          <!-- 论坛主题 -->
          <ul class="theme-box">
            <li v-for="(item, index) in themeArr" :key="index" :class="themeNowId == item.id ? 'theme-active' : ''" @click="changeThemeFn(item.id)">{{ item.name }}</li>
          </ul>
          <!-- Swiper -->
          <div class="live-swiper-wrap" v-show="listFlag">
            <div class="explain-box">
              <div class="explain-txt">
                支持<img src="../assets/image/jiantou1.jpg" />键翻阅图片
              </div>
              <span>|</span>
              <a href="javascript:;" class="looklist-btn" @click="listFlag = false">列表查看</a>
            </div>
            <!-- 大图 -->
            <swiper ref="swiperTop" class="gallery-top" :options="swiperOptions">
              <swiper-slide v-for="(item, index) in details" :key="index">
                <img :src="item.imagePath" />
                <p class="live-swiper-txt">现场花絮</p>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
            <!-- 缩略图 -->
            <div class="thumbnail-box">
              <swiper ref="swiperThumbs" class="gallery-thumbs" :options="Options">
                <swiper-slide v-for="(item, index) in details" :key="index">
                  <img :src="item.imagePath" />
                </swiper-slide>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
              </swiper>
            </div>
          </div>
          <!-- 图片列表显示 -->
          <div class="livelist-wrap" v-show="!listFlag">
            <!-- 高清查看btn -->
            <p class="HD-btn-box"><a href="javascript:;" @click="listFlag = true">高清查看</a></p>
            <!-- 列表 -->
            <ul class="theme-pic">
              <li v-for="(item, index) in details" :key="index" @click="ToSwiperFn(index)">
                <div class="pic-box">
                  <img :src="item.imagePath" />
                </div>
                <p>{{ '现场花絮(' + (index+1) + '/' + details.length +')'}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ispc" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { AccessRecordsApi,LiveHighlightsApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "LiveHighlights",
    data() {
      return {
        name: '现场花絮',
        ispc: false, // false:pc true:mobile
        menuName: '',
        themeArr: [{ name: '主论坛', id: 19, ewmSrc: '../../static/img/theme-0.png' },{ name: '主题论坛一', id: 20, ewmSrc: '../../static/img/theme-1.png' },{ name: '主题论坛二', id: 21, ewmSrc: '../../static/img/theme-2.png' },{ name: '主题论坛三', id: 22, ewmSrc: '../../static/img/theme-3.png' },{ name: '主题论坛四', id: 23, ewmSrc: '../../static/img/theme-4.png' },{ name: '主题论坛五', id: 24, ewmSrc: '../../static/img/theme-5.png' },{ name: '主题论坛六', id: 25, ewmSrc: '../../static/img/theme-6.png' }],
        themeNowId: 19,
        themeDataAll: [],  // 全部主题的图
        details: [],  // 当前主题的图
        swiperOptions: {
          loop: false,
          spaceBetween: 10,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        Options: {
          spaceBetween: 10,
          slidesPerView: 5,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          centeredSlides: true,
          touchRatio: 0.2,
          slideToClickedSlide: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        listFlag: true,  // true:高清 false:列表
      }
    },
    created() {
      let wid = window.innerWidth;
      this.themeNowId = this.$route.query.id;
      if (wid >= 320 && wid <= 1024) {
        this.ispc = false;
      } else {
        this.ispc = true;
      }
    },
    mounted() {
      this.GetLiveDataFn();

      // swiper设置
      let imgInd = this.$route.query.index;
      this.swipertop.slideTo(imgInd, 1000, false);//切换到第n个slide，速度为1秒
      this.swiperthumbs.slideTo(imgInd, 1000, false);//切换到第n个slide，速度为1秒

      setTimeout(()=>{
        this.swipertop.controller.control = this.swiperthumbs;
        this.swiperthumbs.controller.control = this.swipertop;
      },500);
    },
    computed: {
      swipertop() {
        return this.$refs.swiperTop.$swiper
      },
      swiperthumbs() {
        return this.$refs.swiperThumbs.$swiper
      }
    },
    methods: {
      // 获取数据
      GetLiveDataFn(){
        LiveHighlightsApi({
          Sorting: 'displayIndex asc,creationDate asc',
          ChildrenSorting: 'displayIndex asc,creationDate asc'
        }).then(res => {
          this.themeDataAll = res.seminarSubTopics;
          for(let i=0;i<res.seminarSubTopics.length;i++){
            if(this.themeNowId == res.seminarSubTopics[i].id){
              this.details = res.seminarSubTopics[i].seminarNewsList;
              return;
            }
          }
        });
      },
      // 跳到swiper对应的图
      ToSwiperFn(ind){
        this.swipertop.slideTo(ind, 1000, false);//切换到第n个slide，速度为1秒
        this.swiperthumbs.slideTo(ind, 1000, false);//切换到第n个slide，速度为1秒
        this.listFlag = true;
      },
      // 切换论坛
      changeThemeFn(id){
        let flag = false;
        this.themeNowId = id;
        for(let i=0;i<this.themeDataAll.length;i++){
          if(id == this.themeDataAll[i].id){
            this.details = this.themeDataAll[i].seminarNewsList;
            this.swipertop.slideTo(0, 1000, false);//切换到第n个slide，速度为1秒
            this.swiperthumbs.slideTo(0, 1000, false);//切换到第n个slide，速度为1秒
            flag = true;
            return;
          }

          if(i == this.themeDataAll.length - 1 && !flag){
            this.details = [];
          }
        }
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  .live-img{
    width: 100%;
    height: auto;
  }

  .live-txt{
    line-height: 30px;
    text-align: left;
    text-indent: 2em;
    margin-bottom: 30px;
    margin-top: 20px;
    font-size: 17px;
  }

  .live-line{
    height: 1px;
    background-color: #eaeaea;
  }

  .theme-box{
    display: flex;
    border: 1px solid #1058bb;
    margin: 30px 0 15px;
  }

  .theme-box li{
    width: 100%;
    cursor: pointer;
    border-left: 1px solid #1058bb;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
  }

  .theme-box li:first-child{
    border-left: 0;
  }

  .theme-active{
    background-color: #1058bb;
    color: #FFFFFF;
  }

  /* swiper */
  .live-swiper-wrap {
    width: 980px;
    margin: 20px auto 0;
    border: 1px solid #e4e4e4;
    padding: 20px;
  }

  /* 说明 */
  .explain-box{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 16px;
    color: #666666;
    margin: 0 0 20px;
  }

  .explain-txt img{
    margin: 0 5px;
  }

  .explain-box>span{
    padding: 0px 10px;
  }

  .explain-box>a{
    color: #666666;
  }
  /* 大图 */
  .gallery-top img {
    width: 640px;
    /* height: auto; */
    height: 427px;
    /* max-height: 430px; */
  }

  .gallery-top .swiper-slide{
    text-align: center;
  }

  /* 图片描述 */
  .live-swiper-wrap .live-swiper-txt{
    font-size: 14px;
    line-height: 40px;
    margin-top: 20px;
    color: #666666;
  }

  /* 分页器 */
  .gallery-top .swiper-pagination-fraction{
    width: 100px;
    font-size: 20px;
    color: #666666;
  }

  /* 缩略图 */
  .thumbnail-box{
    width: 680px;
    margin: 20px auto 0;
    padding: 0 40px;
    position: relative;
  }

  .gallery-thumbs {
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    position: initial;
  }

  .gallery-thumbs .swiper-slide {
    opacity: 0.4;
  }

  .gallery-thumbs img{
    width: 100%;
    height: 100%;
  }

  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

  /* 列表 */
  .livelist-wrap{
    width: 978px;
    border: 1px solid #e4e4e4;
    margin: 20px auto 0px;
    overflow: hidden;
  }

  .HD-btn-box{
    text-align: right;
    line-height: 50px;
    border-bottom: 1px solid #e4e4e4;
  }

  .HD-btn-box a{
    font-size: 16px;
    padding-right: 10px;
  }

  /* 图 */
  .theme-pic{
    display: flex;
    flex-wrap: wrap;
  }

  .theme-pic li{
    width: 25%;
    padding: 20px 0;
    border-bottom: 1px solid #e4e4e4;
    border-right: 1px solid #e4e4e4;
  }

  .theme-pic li:nth-child(4n){
    border-right: none;
  }

  .theme-pic .pic-box{
    padding: 0px 10px;
    height: 160px;
    width: 100%;
  }

  .theme-pic li img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .theme-pic li p{
    text-align: center;
    font-size: 14px;
    line-height: 26px;
    margin-top: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/LiveDetails.vue